import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { useDispatch, useSelector } from 'react-redux';
import { contactUsLisitingRequest, deleteContactUs, updaqteContactUs } from './redux/contactUsDispatcher';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';
import AddPriorityPopup from './components/AddPriorityPopup';
import AddStatusPopup from './components/AddStatusPopup';

import {
  DropdownWrapper, Dropdown, ChevronIcon,
} from '../dashboard/dashborad_styles';

function ContactUsListingTable() {
  const dispatch = useDispatch();
  const location = useLocation();
  const contactUsListing = useSelector(state => state.contactUsReducer);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [keyword, setKeyword] = useState("");
  const [priority, setPriority] = useState(null);
  const [status, setStatus] = useState(null);


  const priorityOptions = [
    { value: 1, label: "Low" },
    { value: 2, label: "Medium" },
    { value: 3, label: "High" }
  ];

  const statusOptions = [
    { value: 0, label: "Pending" },
    { value: 1, label: "In Progress" },
    { value: 2, label: "Completed" }
  ];



  const columns = [
    {
      field: "id",
      headerName: "NO",
      width: 60,
      renderCell: (params) =>
        params.api.getRowIndexRelativeToVisibleRows(params.id) + 1 + (page * pageSize),
    },
    { field: "created_at", headerName: "Created At", width: 110 },

    { field: "name", headerName: "Name", width: 150 },
    { field: "email", headerName: "Email", width: 150 },
    { field: "subject", headerName: "Subject", width: 150 },


 {
  field: "priority",
  headerName: "Priority",
  width: 100,
  renderCell: (params) => {
    const value = Number(params.value);

    const label =
      value === 3 ? "High" :
      value === 2 ? "Medium" :
      value === 1 ? "Low" : "-";

    const bgColor =
      value === 3
        ? "#ff4d4d"   // red
        : value === 2
        ? "#ffb84d"   // orange
        : value === 1
        ? "#4CAF50"   // green
        : "#d9d9d9";  // grey for blank

    return (
      <span
        style={{
          padding: "4px 8px",
          borderRadius: "6px",
          color: "white",
          fontSize: "12px",
          backgroundColor: bgColor,
          textTransform: "capitalize",
        }}
      >
        {label}
      </span>
    );
  },
},


{
  field: "status",
  headerName: "Status",
  width: 100,
  renderCell: (params) => {
    const value = Number(params.value);

    const label =
      value === 2 ? "Completed" :
      value === 1 ? "In Progress" :
      value === 0 ? "Pending" : "-";

    const bgColor =
      value === 2
        ? "#4CAF50"   // green - completed
        : value === 1
        ? "#ff9800"   // orange - progress
        : value === 0
        ? "#9e9e9e"   // grey - pending
        : "#d9d9d9";  // fallback

    return (
      <span
        style={{
          padding: "4px 8px",
          borderRadius: "6px",
          color: "white",
          fontSize: "12px",
          backgroundColor: bgColor,
          textTransform: "capitalize",
        }}
      >
        {label}
      </span>
    );
  },
}
,
    {
      field: "action",
      headerName: "Action",
      width: 300,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", gap: "6px", height: "100%", alignItems: "center" }}>

          <AddStatusPopup
            userData={params.row}
            onSubmit={(s) => {

              var data = {
                id: params.row.id,
                status: s
              }
              dispatch(updaqteContactUs(data, page + 1, pageSize, keyword, priority, status));

            }}


          />

          <AddPriorityPopup
            userData={params.row}
            onSubmit={(p) => {
              var data = {
                id: params.row.id,
                priority: p
              }
              dispatch(updaqteContactUs(data, page + 1, pageSize, keyword, priority, status));
            }}

          />



          <button
            onClick={() => handleDelete(params.row)}
            style={{
              backgroundColor: "#F44336",
              color: "white",
              border: "none",
              borderRadius: "4px",
              fontSize: "10px",
              padding: "4px 8px",
              cursor: "pointer",
              minWidth: "40px",
              height: "24px",  // Increased height
              display: "flex",
              alignItems: "center",
              // alignSelf:"end",
              justifyContent: "center",
            }}
          >
            Archive
          </button>


        </div>
      )
    }
  ];

  const handleDelete = (row) => {
    Swal.fire({
      title: '',
      html: `Are you sure?<br>You want to archive this "${row.name}" request`,
      showCancelButton: true,
      confirmButtonText: 'Yes, Delete',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then(result => {
      if (result.isConfirmed) {
        dispatch(deleteContactUs(row.id, page + 1, pageSize, keyword, priority, status));
      }
    });
  };

  useEffect(() => {
    dispatch(contactUsLisitingRequest(page + 1, pageSize, keyword, priority, status));

  }, [page, pageSize, dispatch, location.pathname, status, priority, keyword]);



  return (
    <Paper sx={{ height: "95%", width: '100%' }}>

      <div
        style={{
          padding: "10px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Search Input */}
        <input
          type="text"
          placeholder="Search name , email , subject..."
          value={keyword}
          onChange={(e) => {
            setPage(0);
            setKeyword(e.target.value);
          }}
          style={{
            padding: "6px 10px",
            fontSize: "14px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            width: "30%",
          }}
        />

        {/* Dropdowns + Buttons */}
        <div style={{ display: "flex", gap: "15px", alignItems: "center" }}>

          {/* Priority Dropdown */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ marginBottom: "4px", fontSize: "12px", fontWeight: "600" }}>
              Priority
            </label>
            <DropdownWrapper>
              <Dropdown
                value={priority ?? ""}
                onChange={(e) => {
                  setPage(0);

                  setPriority(Number(e.target.value));

                }}
              >
                <option value="" disabled>Select Priority</option>
                {priorityOptions.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Dropdown>
              <ChevronIcon size={16} />
            </DropdownWrapper>
          </div>

          {/* Status Dropdown */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ marginBottom: "4px", fontSize: "12px", fontWeight: "600" }}>
              Status
            </label>
            <DropdownWrapper>
              <Dropdown
                value={status ?? ""}
                onChange={(e) => {
                  setPage(0);
                  setStatus(Number(e.target.value))
                }}
              >
                <option value="" disabled>Select Status</option>
                {statusOptions.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </Dropdown>
              <ChevronIcon size={16} />
            </DropdownWrapper>
          </div>


        </div>
      </div>



      <DataGrid
        rows={contactUsListing.contactUsListing || []}
        columns={columns}
        rowCount={contactUsListing.totalContactUs || 0}
        paginationModel={{ page, pageSize }}
        paginationMode="server"
        onPaginationModelChange={({ page, pageSize }) => {
          console.log("pagination----", page, pageSize);
          setPage(page);
          setPageSize(pageSize);
        }}
        pageSizeOptions={[10, 25, 50]}
        loading={contactUsListing.loading}
        rowHeight={36}
        disableRowSelectionOnClick
      />
    </Paper>
  );
}

export default ContactUsListingTable;
